import { mapGetters, mapMutations } from 'vuex'
import HomeLeftArrow from '@/components/@icons/HomeLeftArrow.vue'
import HomeRightArrow from '@/components/@icons/HomeRightArrow.vue'
import { Carousel, Slide } from 'vue-carousel'

export default {
    name: 'HomePartners',
    components: {
        Carousel,
        Slide,
        HomeLeftArrow,
        HomeRightArrow,
    },
    computed: {
        ...mapGetters({
            homePage: 'pages/page',
            isAuthenticated: 'auth/isAuthenticated',
        }),
        showSlider() {
            const breakPoints = [
                {size: 200, slides: 1},
                {size: 320, slides: 2},
                {size: 901, slides: 3},
                {size: 1150, slides: 4}]

            const foundSlider = breakPoints.find(item => item.size <= this.windowSize)
            if (foundSlider) {
                return foundSlider.slides > this.homePage.partners.data
            }
            return false
        }
    },
    data() {
        return {
            windowSize: window.innerWidth
        }
    },
    methods: {
        ...mapMutations({
            changeRegisterPopup: 'popups/CHANGE_REGISTRATION_POPUP',
        }),
        carouselNav(event, direction) {
            const carousel = this.$refs.carouselPartners
            if (carousel) {
                carousel.advancePage(direction)
            }
        },
    },
}
